import { render, staticRenderFns } from "./RespostaCardCotacao.vue?vue&type=template&id=888f1072"
import script from "./RespostaCardCotacao.vue?vue&type=script&lang=js"
export * from "./RespostaCardCotacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports